import {connect} from '@modifi/redux'
import {aPush, generatePath} from '@modifi/router'
import {compose} from 'ramda'
import {FeInputFieldStatus} from '@modifi/enums'

import {selectLegalRepresentativesAreLoading} from '../../../../data/legal-representatives'
import {selectCombinedInputFieldStatusBySectionName} from '../../../../modules/input-fields'
import LegalRepSummaryPage, {LegalRepSummaryPageProps} from './LegalRepSummaryPage'
import {SECTION_LEGAL_REPRESENTATIVES} from '../../../../constants/sections'
import {selectCompanyIsLocked} from '../../../../data/company'
import {selectLegalRepSummaryData} from './selector'
import {ROUTE_COMPANY_PROFILE_LEGAL_REPRESENTATIVES_CREATE} from '../../../../routes/constants'
import {
  aEnsureFetchResolvedPublicRegisteredCompanyDetails,
  aEnsurePublicRegisteredCompanies,
  selectHasLegalRepresentatives,
  selectPublicRegisteredCompaniesRetrievalStatus,
  selectResolvedPublicRegisteredCompanyDetailsAreLoading,
} from '../../../../data/public-registered-companies'

const mapStateToProps = (
  state: Record<string, any>
): Pick<
  LegalRepSummaryPageProps,
  'isLoading' | 'legalRepSummary' | 'isReadonly' | 'hasLegalRepsFromProvider' | 'retrievalStatus'
> => {
  const companyIsLocked = selectCompanyIsLocked(state)
  const isVerified =
    selectCombinedInputFieldStatusBySectionName(state, SECTION_LEGAL_REPRESENTATIVES) ===
    FeInputFieldStatus.VERIFIED

  return {
    isLoading:
      selectLegalRepresentativesAreLoading(state) ||
      selectResolvedPublicRegisteredCompanyDetailsAreLoading(state),
    legalRepSummary: selectLegalRepSummaryData(state),
    isReadonly: isVerified || companyIsLocked,
    hasLegalRepsFromProvider: selectHasLegalRepresentatives(state),
    retrievalStatus: selectPublicRegisteredCompaniesRetrievalStatus(state),
  }
}

const mapDispatchToProps = {
  createLegalRep: (): any =>
    aPush(generatePath(ROUTE_COMPANY_PROFILE_LEGAL_REPRESENTATIVES_CREATE, {})),
  fetchResolvedCompanyDetails: aEnsureFetchResolvedPublicRegisteredCompanyDetails,
  fetchPublicRegisteredCompanies: aEnsurePublicRegisteredCompanies,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(LegalRepSummaryPage)
